import { trackEvent } from "./analytics";

type SearchOpenMethod = "click" | "keyboard" | "route" | "unknown";
type SearchResultType = "podcast" | "episode";
type SearchHistoryType = "recent" | "saved";

let pendingOpenMethod: SearchOpenMethod = "unknown";

export function markSearchOpenMethod(method: SearchOpenMethod) {
    pendingOpenMethod = method;
}

export function consumeSearchOpenMethod() {
    const method = pendingOpenMethod;
    pendingOpenMethod = "unknown";
    return method;
}

export const searchAnalytics = {
    opened(method: SearchOpenMethod) {
        trackEvent({
            action: "opened",
            category: "search",
            metadata: {
                method,
            },
        });
    },
    queried(query: string, resultCount: number) {
        trackEvent({
            action: "query",
            category: "search",
            metadata: {
                query_length: query.length,
                result_count: resultCount,
            },
        });
    },
    resultClicked(type: SearchResultType, position: number, query: string) {
        trackEvent({
            action: "result_clicked",
            category: "search",
            metadata: {
                position,
                query_length: query.length,
                result_type: type,
            },
        });
    },
    noResults(query: string) {
        trackEvent({
            action: "no_results",
            category: "search",
            metadata: {
                query_length: query.length,
            },
        });
    },
    saved(query: string) {
        trackEvent({
            action: "saved",
            category: "search",
            metadata: {
                query_length: query.length,
            },
        });
    },
    historyUsed(type: SearchHistoryType, query: string) {
        trackEvent({
            action: "history_used",
            category: "search",
            metadata: {
                history_type: type,
                query_length: query.length,
            },
        });
    },
    closed(selectedResult: boolean, timeSpentMs: number) {
        trackEvent({
            action: "closed",
            category: "search",
            metadata: {
                selected_result: selectedResult,
                time_spent_ms: timeSpentMs,
            },
        });
    },
};
